import React, { useState } from 'react'
import { ListScreen } from '../../components'
import { GridColumn } from '@progress/kendo-react-grid'
import { useTranslation } from 'react-i18next'

const ColorSize = ({ colorid, productid }) => {
    const [userSendData] = useState({ colorid, productid })
    const { t } = useTranslation();
    return (
        <div>
            <ListScreen
                read={'ml000023'}
                save_pc={'ml000024'}
                delete={'ml000025'}
                userSendData={userSendData}
                filterable={false}
                editable={true}
            >
                <GridColumn field='size' title={t('size')} />
                <GridColumn field='count' title={t('count')} editor="numeric"/>
            </ListScreen>
        </div>
    )
}

export default ColorSize